import HttpClienteToken from '../../services/HttpClientToken';

import { MunicipioProps } from '../../interfaces/catalogos/MunicipioInterface';

export const Municipios = () => {

    return new Promise<MunicipioProps[]>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if ( data ) {

            const { token } = data;

            HttpClienteToken.get('/Api/Municipio/', token)
            .then(({ data }: { data: MunicipioProps[] }) => {
                resolve(data);
            })
            .catch(() => {
                resolve([]);
            });
        }

    });

}

export const ObtenerMunicipio = (id: number) => {

    return new Promise<MunicipioProps[]>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if ( data ) {

            const { token } = data;

            HttpClienteToken.get(`/Api/Municipio/ObtenerMunicipios/${ id }`, token)
            .then(({ data }: { data: MunicipioProps[] }) => {
                resolve(data);
            })
            .catch(() => {
                resolve([]);
            });
        }

    });

}

export const ActualizarMunicipio = (params: MunicipioProps) => {

    return new Promise<MunicipioProps>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if ( data ) {
            const { token } = data;

            HttpClienteToken.post('/Api/Municipio/Actualizar', params, token)
            .then(({ data }: { data: MunicipioProps }) => {
                resolve(data);
            })
            .catch(() => {
                resolve({
                    idMunicipio: 0,
                    clave: "",
                    descripcion: '',
                    activo: false,
                    idEstado: 0,
                });
            });
        }

    });

}

export const AgregarMunicipio = (params: MunicipioProps) => {

    return new Promise<MunicipioProps>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if ( data ) {

            const { token } = data;

            HttpClienteToken.post('/Api/Municipio/Agregar', params, token)
            .then(({ data }: { data: MunicipioProps }) => {
                resolve(data);
            })
            .catch(() => {
                resolve({
                    idMunicipio: 0,
                    clave: "",
                    descripcion: '',
                    activo: false,
                    idEstado: 0,
                });
            });
        }

    });

}